// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mesocycle-info {
  font-size: 14px;
  color: var(--ons-color-black-2);
  font-family: var(--ons-font-bold);
  text-align: center;
  margin-bottom: 40px;
}
.mesocycle-info span {
  color: var(--ons-color-red);
}
.mesocycle-info span.positive {
  color: var(--ons-color-primary);
}

.top-title {
  text-align: center;
  margin-bottom: 10px;
}

.recalc-button {
  display: flex;
  align-items: center;
  font-size: 12px;
  height: 37px;
  font-family: var(--ons-font-semibold);
  margin: 0;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
}
.recalc-button ion-icon {
  margin-right: 10px;
}

.tolerance-label {
  font-family: var(--ons-font-light);
  color: var(--ons-color-primary-black);
  font-size: 14px;
}

.details-title {
  font-family: var(--ons-font-bold);
  color: var(--ons-color-black-2);
  font-size: 16px;
  text-align: center;
  margin-top: 40px;
}

.unit-selector {
  margin-top: 30px;
  margin-bottom: 10px;
}
.unit-selector ion-segment {
  --background: var(--ons-color-light-grey);
  border-radius: 40px;
  height: 40px;
}
.unit-selector ion-segment ion-segment-button {
  font-weight: 700;
  --border-radius: 40px;
  --indicator-box-shadow: none;
  --border-color: transparent;
}

.custom-pin {
  font-size: 15px;
  transform: translateX(-50%);
  top: 45px;
  position: absolute;
  left: 0;
  text-align: center;
}

.nutrition-total {
  font-family: var(--ons-font-light);
  color: var(--ons-color-primary-black);
  font-size: 14px;
}
.nutrition-total b {
  font-family: var(--ons-font-bold);
  color: var(--ons-color-green);
}
.nutrition-total b.fail {
  color: var(--ons-color-red);
}

.slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.slider-header .auto-button {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: var(--ons-font-medium);
  color: var(--ons-color-black-2);
}
.slider-header .auto-button ion-radio {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/edit-nutrition/edit-nutrition.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,+BAAA;EACA,iCAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;EACI,2BAAA;AACR;AACQ;EACI,+BAAA;AACZ;;AAGA;EACI,kBAAA;EACA,mBAAA;AAAJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,qCAAA;EACA,SAAA;EACA,uBAAA;EAAA,kBAAA;EACA,iBAAA;AACJ;AACI;EACI,kBAAA;AACR;;AAEA;EACI,kCAAA;EACA,qCAAA;EACA,eAAA;AACJ;;AACA;EACI,iCAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,mBAAA;AAEJ;AAAI;EACI,yCAAA;EACA,mBAAA;EACA,YAAA;AAER;AADQ;EACI,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAGZ;;AAEA;EACI,eAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kCAAA;EACA,qCAAA;EACA,eAAA;AACJ;AACI;EACI,iCAAA;EACA,6BAAA;AACR;AACQ;EACI,2BAAA;AACZ;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,+BAAA;AADR;AAGQ;EACI,iBAAA;AADZ","sourcesContent":[".mesocycle-info {\n    font-size: 14px;\n    color: var(--ons-color-black-2);\n    font-family: var(--ons-font-bold);\n    text-align: center;\n    margin-bottom: 40px;\n\n    span {\n        color: var(--ons-color-red);\n\n        &.positive {\n            color: var(--ons-color-primary);\n        }\n    }\n}\n.top-title {\n    text-align: center;\n    margin-bottom: 10px;\n}\n.recalc-button {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    height: 37px;\n    font-family: var(--ons-font-semibold);\n    margin: 0;\n    width: fit-content;\n    margin-left: auto;\n\n    ion-icon {\n        margin-right: 10px;\n    }\n}\n.tolerance-label {\n    font-family: var(--ons-font-light);\n    color: var(--ons-color-primary-black);\n    font-size: 14px;\n}\n.details-title {\n    font-family: var(--ons-font-bold);\n    color: var(--ons-color-black-2);\n    font-size: 16px;\n    text-align: center;\n    margin-top: 40px;\n}\n\n.unit-selector {\n    margin-top: 30px;\n    margin-bottom: 10px;\n\n    ion-segment {\n        --background: var(--ons-color-light-grey);\n        border-radius: 40px;\n        height: 40px;\n        ion-segment-button {\n            font-weight: 700;\n            --border-radius: 40px;\n            --indicator-box-shadow: none;\n            --border-color: transparent;\n        }\n    }\n}\n\n.custom-pin {\n    font-size: 15px;\n    transform: translateX(-50%);\n    top: 45px;\n    position: absolute;\n    left: 0;\n    text-align: center;\n}\n\n.nutrition-total {\n    font-family: var(--ons-font-light);\n    color: var(--ons-color-primary-black);\n    font-size: 14px;\n\n    b {\n        font-family: var(--ons-font-bold);\n        color: var(--ons-color-green);\n\n        &.fail {\n            color: var(--ons-color-red);\n        }\n    }\n}\n\n.slider-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .auto-button {\n        display: flex;\n        align-items: center;\n        font-size: 14px;\n        font-family: var(--ons-font-medium);\n        color: var(--ons-color-black-2);\n\n        ion-radio {\n            margin-right: 5px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
